import {COLORS} from "shared/consts"
import {
  PesticideMapClusterWrapper,
  PesticideMapContent,
  PesticideMapContentHead,
  PesticideMapContentRow,
  PesticideMapContentTitle,
  PesticideMapCreatePointBody,
  PesticideMapCreatePointFooter,
  PesticideMapCreatePointHead,
  PesticideMapCreatePointItem,
  PesticideMapCreatePointTitle,
  PesticideMapCreatePointWrapper,
  PesticideMapDeletePointModalBody,
  PesticideMapDeletePointModalFooter,
  PesticideMapDeletePointModalHead,
  PesticideMapDeletePointModalText,
  PesticideMapMarker,
  PesticideMapMarkerWrapper,
  PesticideMapNoPolygonsModalContent,
  PesticideMapNoPolygonsModalIcon,
  PesticideMapNoPolygonsModalText,
  PesticideMapNoPolygonsModalTitle,
  PesticideMapNoPolygonsModalWrapper,
  PesticideMapPointFeatureWrapper,
  PesticideMapWrapper
} from "./styles"
import {ExpandedFeature, usePesticideMap} from "../lib/usePesticideMap"
import {LngLat, PolygonGeometry} from "@yandex/ymaps3-types";
import {CloseIcon, NotificationInfoIcon} from "shared/ui/icons";
import {toRem} from "shared/helpers";
import {Drawer} from "shared/ui/drawer";
import {useResize} from "app/lib/hooks/useResize";
import {Spacer} from "shared/ui/spacer";
import {Controller} from "react-hook-form";

import Button from '@atomaro/ui-kit/components/Button/Button/Button';
import Input from '@atomaro/ui-kit/components/Input/Input';
import Modal from '@atomaro/ui-kit/components/Modal/Modal';
import {PesticideMapSidebar} from "./PesticideMapSidebar";
import {PesticideMapFilters} from "./PesticideMapFilters";
import {PesticideMapPolygonModal} from "./PesticideMapPolygonModal";
import {useReactify} from "shared/api";
import {useContext} from "react";
import {ConfigContext} from "../../../app/App.tsx";

export const PesticideMap = () => {
  const {
    location,
    mapInstance,
    apiariesFeatures,
    openApiaryId,
    pointsFeatures,
    pointStyle,
    createdPoint,
    createPointForm,
    isDeleteModalOpen,
    isFiltersOpen,
    isNotPesticidesModalOpen,
    polygonsFeatures,
    activePolygon,
    activePolygonModalPosition,
    isPolygonModalOpen,
    isCreatePointOpen,
    onClusterClick,
    setOpenApiaryId,
    onMapClick,
    onCreatePointClose,
    onCoordinatesChange,
    onRadiusChange,
    onCreatePointSubmit,
    onCloseCreatePointClick,
    onDeleteModalClose,
    onDeleteModalSubmit,
    createPoint,
    setIsFiltersOpen,
    setIsNotPesticidesModalOpen,
    closePolygonModal,
    onMapUpdate,
    onFiltersSubmit
  } = usePesticideMap();
  const {VITE_YANDEX_TOKEN} = useContext(ConfigContext);

  const {
    isScreenMd
  } = useResize()
  
  const reactify = useReactify(VITE_YANDEX_TOKEN)
  if (!reactify) return null;
  
  const gridSizedMethod = reactify.clusterByGrid({gridSize: 64})
  
  const marker = (feature: ExpandedFeature) => (
    <reactify.YMapMarker
      coordinates={feature.geometry.coordinates} 
      onClick={() => setOpenApiaryId(openApiaryId === feature.properties?.apiary.id ? null : (feature.properties?.apiary.id || null))}
    >
      <PesticideMapMarkerWrapper className="pesticide-map-marker">
        <PesticideMapMarker>
          <svg width="47" height="53" viewBox="0 0 47 53" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M26.1924 0.726927C24.5267 -0.242257 22.4733 -0.242313 20.8076 0.726782L2.69324 11.2624C1.02672 12.2316 0 14.0229 0 15.9615V37.037C0 38.9754 1.02673 40.7666 2.69244 41.7358L20.8076 52.2731C22.4733 53.2423 24.5267 53.2423 26.1924 52.2731L44.3076 41.7358C45.9733 40.7666 47 38.9754 47 37.037V15.9629C47 14.0245 45.9733 12.2332 44.3076 11.264L26.1924 0.726927Z" fill={COLORS.ACCENT.DEFAULT} className="polygon" />
            <path d="M28.6218 30.7159C29.1209 30.7159 29.5256 31.1204 29.5256 31.6193C29.5256 32.1182 29.1209 32.5227 28.6218 32.5227H25.6089C25.1098 32.5227 24.7051 32.1182 24.7051 31.6193C24.7051 31.1204 25.1098 30.7159 25.6089 30.7159H28.6218Z" fill={COLORS.NEUTRAL.ON_NEUTRAL}/>
            <path fillRule="evenodd" clipRule="evenodd" d="M35.25 24.0909C35.4164 24.0909 35.5512 24.2257 35.5512 24.392V29.2102C35.5512 29.3765 35.4164 29.5113 35.25 29.5113H34.3461V36.1363C34.3461 37.4669 33.267 38.5454 31.9359 38.5454H22.2948C20.9637 38.5454 19.8846 37.4669 19.8846 36.1363V29.5113H18.9807C18.8143 29.5113 18.6794 29.3765 18.6794 29.2102V24.392C18.6794 24.2257 18.8143 24.0909 18.9807 24.0909H35.25ZM21.6923 36.1363C21.6923 36.469 21.962 36.7386 22.2948 36.7386H31.9359C32.2686 36.7386 32.5384 36.469 32.5384 36.1363V29.5113H21.6923V36.1363ZM20.4871 27.7045H33.7436V25.8977H20.4871V27.7045Z" fill={COLORS.NEUTRAL.ON_NEUTRAL}/>
            <path fillRule="evenodd" clipRule="evenodd" d="M29.2243 14.4545C29.3907 14.4545 29.5256 14.5894 29.5256 14.7557V19.5738C29.5256 19.7402 29.3907 19.875 29.2243 19.875H28.3205V21.6818H26.5128V19.875H15.6666V26.5C15.6666 26.8326 15.9364 27.1023 16.2692 27.1023V28.9091C14.938 28.9091 13.8589 27.8305 13.8589 26.5V19.875H12.9551C12.7887 19.875 12.6538 19.7402 12.6538 19.5738V14.7557C12.6538 14.5894 12.7887 14.4545 12.9551 14.4545H29.2243ZM14.4615 18.0682H27.7179V16.2613H14.4615V18.0682Z" fill={COLORS.NEUTRAL.ON_NEUTRAL}/>
          </svg>
        </PesticideMapMarker>
        <PesticideMapContent $isActive={openApiaryId === feature.properties?.apiary.id}>
          <PesticideMapContentHead>
            <PesticideMapContentTitle>
              Информация о пасеке
            </PesticideMapContentTitle>
            <Button 
              colorScheme="neutral"
              iconPrefix={<CloseIcon />}
              size="m"
              variant="secondary"
              style={{width: toRem(36)}}
              onClick={() => setOpenApiaryId(null)}
            />
          </PesticideMapContentHead>
          <PesticideMapContentRow>
            <span>Название пасеки:</span>
            <p>{feature.properties?.apiary.name}</p>
          </PesticideMapContentRow>
          <PesticideMapContentRow>
            <span>Координаты пасеки:</span>
            <p>{feature.geometry.coordinates.join(', ')}</p>
          </PesticideMapContentRow>
        </PesticideMapContent>
      </PesticideMapMarkerWrapper>
    </reactify.YMapMarker>
  );

  const cluster = (coordinates: LngLat, features: ExpandedFeature[]) => (
    <reactify.YMapMarker coordinates={coordinates} onClick={() => onClusterClick(features)}>
      <PesticideMapClusterWrapper>
        <svg width="71" height="78" viewBox="0 0 71 78" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M39.5673 1.06982C37.051 -0.356529 33.949 -0.356611 31.4327 1.0696L4.06851 16.5748C1.55101 18.0012 0 20.6374 0 23.4905V54.5072C0 57.36 1.55102 59.9961 4.0673 61.4225L31.4327 76.9302C33.949 78.3566 37.051 78.3566 39.5673 76.9302L66.9327 61.4225C69.449 59.9961 71 57.36 71 54.5072V23.4926C71 20.6398 69.449 18.0036 66.9327 16.5772L39.5673 1.06982Z" fill={COLORS.BG.SURFACE1} className="polygon"/>
          <path d="M32.8516 12.5575C34.2313 11.7774 35.9367 11.7772 37.3164 12.5575V12.5585L57.3057 23.8603C58.6825 24.6391 59.5156 26.0677 59.5156 27.5956V50.2011C59.5155 51.7289 58.6824 53.1567 57.3057 53.9355L37.3164 65.2382C36.0227 65.9699 34.4427 66.0162 33.1133 65.3759L32.8516 65.2382L12.8613 53.9355H12.8623C11.4855 53.1567 10.6525 51.7289 10.6523 50.2011V27.5937C10.6524 26.0657 11.4849 24.6381 12.8623 23.8593L32.8516 12.5575Z" stroke={COLORS.ACCENT.DEFAULT} strokeWidth="3"/>
        </svg>
        <span>{features.length}</span>
      </PesticideMapClusterWrapper>
    </reactify.YMapMarker>
  );

  return (
    <PesticideMapWrapper $isFiltersOpen={isFiltersOpen||isCreatePointOpen}>
      <reactify.YMap location={reactify.reactify.useDefault(location, [location])} ref={mapInstance}>
        <reactify.YMapDefaultSchemeLayer
          source='scheme'
        />
        {/* <YMapDefaultSatelliteLayer /> */}
        <reactify.YMapDefaultFeaturesLayer />
        {
          apiariesFeatures && <reactify.YMapClusterer marker={marker} cluster={cluster} method={gridSizedMethod} features={reactify.reactify.useDefault(apiariesFeatures, [apiariesFeatures])} />
        }
        
        {pointsFeatures.map(({point}) => {
          return (
            <reactify.YMapFeature
              id={point.properties.id}
              geometry={point.geometry as PolygonGeometry}
              style={pointStyle}
              key={point.properties.id}
              properties={point.properties}
            />
          )
        })}
        {pointsFeatures.map(({feature}) => {
          return (
            <reactify.YMapMarker
              coordinates={feature.geometry.coordinates}
              key={feature.id}
              properties={feature.properties}
            >
              <PesticideMapPointFeatureWrapper>
                <svg width="47" height="64" viewBox="0 0 47 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M26.1924 0.726927C24.5267 -0.242257 22.4733 -0.242313 20.8076 0.726782L2.69324 11.2624C1.02672 12.2316 0 14.0229 0 15.9615V37.037C0 38.9754 1.02673 40.7666 2.69244 41.7358L20.8076 52.2731C22.4733 53.2423 24.5267 53.2423 26.1924 52.2731L44.3076 41.7358C45.9733 40.7666 47 38.9754 47 37.037V15.9629C47 14.0245 45.9733 12.2332 44.3076 11.264L26.1924 0.726927Z" fill={COLORS.NEUTRAL.ON_NEUTRAL}/>
                  <path fillRule="evenodd" clipRule="evenodd" d="M31.9353 23.4677C31.9353 25.4833 31.626 26.8903 30.5362 28.703C29.4162 30.566 27.4802 32.8435 24.1059 36.4602C20.7274 32.8432 18.7894 30.5656 17.6685 28.7026C16.5779 26.8901 16.2686 25.4833 16.2686 23.4677C16.2686 19.7832 19.6879 16.2614 24.102 16.2614C28.516 16.2614 31.9353 19.7832 31.9353 23.4677ZM33.743 23.4677C33.743 28.0564 32.2431 30.4217 24.9842 38.167C24.5104 38.6725 23.7027 38.6728 23.2286 38.1675C15.9609 30.4218 14.4609 28.0565 14.4609 23.4677C14.4609 18.6997 18.7774 14.4545 24.102 14.4545C29.4266 14.4545 33.743 18.6997 33.743 23.4677ZM25.9097 24.0909C25.9097 25.0888 25.1003 25.8977 24.102 25.8977C23.1036 25.8977 22.2943 25.0888 22.2943 24.0909C22.2943 23.093 23.1036 22.2841 24.102 22.2841C25.1003 22.2841 25.9097 23.093 25.9097 24.0909ZM27.7173 24.0909C27.7173 26.0867 26.0987 27.7045 24.102 27.7045C22.1052 27.7045 20.4866 26.0867 20.4866 24.0909C20.4866 22.0952 22.1052 20.4773 24.102 20.4773C26.0987 20.4773 27.7173 22.0952 27.7173 24.0909Z" fill={COLORS.ACCENT.DEFAULT}/>
                  <circle cx="23.5" cy="59.5" r="4.5" fill={COLORS.NEUTRAL.ON_NEUTRAL}/>
                  <circle cx="23.5" cy="59.5" r="2.5" fill={COLORS.ACCENT.DEFAULT}/>
                </svg>
              </PesticideMapPointFeatureWrapper>
            </reactify.YMapMarker>
          )
        })}

        {polygonsFeatures.map(polygon => (
          <reactify.YMapFeature
            key={polygon.id}
            id={`${polygon.id}`}
            geometry={polygon.geometry}
            style={polygon.style}
          />
        ))}

        <reactify.YMapListener
          onClick={onMapClick}
          onUpdate={onMapUpdate}
        />
        <PesticideMapSidebar 
          isMobile={!isScreenMd}
          onCreateClcik={() => createPoint()}
          onFiltersClcik={() => setIsFiltersOpen(true)}
          isFiltersOpen={isFiltersOpen||isCreatePointOpen}
        />
      </reactify.YMap>

      <Drawer
        isOpen={isCreatePointOpen}
        position="right"
        onClose={onCreatePointClose}
        showOverlay={Boolean(createdPoint)}
      >
        <PesticideMapCreatePointWrapper onSubmit={createPointForm.handleSubmit(onCreatePointSubmit)}>
          <PesticideMapCreatePointHead $isMobile={!isScreenMd}>
            <Button 
              iconPrefix={<CloseIcon />}
              variant={!isScreenMd ? 'ghost' : "secondary"}
              colorScheme="neutral"
              style={{alignSelf: 'flex-end', width: !isScreenMd ? toRem(24) : toRem(36)}}
              size={!isScreenMd ? 's' : 'm'}
              onClick={onCreatePointClose}
            />
            <PesticideMapCreatePointTitle>
              Добавить метку
            </PesticideMapCreatePointTitle>
            {!isScreenMd && <Spacer width={toRem(24)} height={toRem(24)} />}
          </PesticideMapCreatePointHead>
          <PesticideMapCreatePointBody>
            <PesticideMapCreatePointItem>
              <h3>Координаты метки</h3>
              <Controller 
                control={createPointForm.control}
                name='coordinates'
                rules={{required: 'Ошибка ввода координат'}}
                render={({field}) => (
                  <Input 
                    name={field.name}
                    value={field.value}
                    size="l"
                    placeholder="Введите координаты"
                    error={createPointForm.formState.errors.coordinates?.message}
                    onChange={(event) => onCoordinatesChange(event.target.value)}
                  />
                )}
              />
            </PesticideMapCreatePointItem>
            <PesticideMapCreatePointItem>
              <h3>Радиус (км.)</h3>
              <Controller 
                control={createPointForm.control}
                name='radius'
                rules={{required: 'Некорректный радиус'}}
                render={({field}) => (
                  <Input 
                    name={field.name}
                    value={field.value}
                    size="l"
                    placeholder="Введите значение от 1 до 15"
                    onChange={(event) => onRadiusChange(event.target.value)}
                    error={createPointForm.formState.errors.radius?.message}
                  />
                )}
              />
            </PesticideMapCreatePointItem>
          </PesticideMapCreatePointBody>
          <PesticideMapCreatePointFooter>
            <Button 
              label="Сохранить"
              type="submit"
            />
            <Button 
              label="Удалить метку"
              type="button"
              variant="secondary"
              onClick={onCloseCreatePointClick}
            />
          </PesticideMapCreatePointFooter>
        </PesticideMapCreatePointWrapper>
      </Drawer>
      <Modal
        isOpen={isDeleteModalOpen}
        centered
        useInPortal
        maxWidth={toRem(333)}
        onClickOverlay={onDeleteModalClose}
        onEsc={onDeleteModalClose}
      >
        <PesticideMapDeletePointModalBody>
          <PesticideMapDeletePointModalHead>
            <Spacer width={toRem(24)} height={toRem(24)} />
            <h3>Удалить эту метку с карты?</h3>
            <Button 
              iconPrefix={<CloseIcon />}
              variant="secondary"
              colorScheme="neutral"
              style={{alignSelf: 'flex-end', width: toRem(24)}}
              size="s"
              onClick={onDeleteModalClose}
            />
          </PesticideMapDeletePointModalHead>
          <PesticideMapDeletePointModalText>
            Метка будет удалена без возможности восстановления
          </PesticideMapDeletePointModalText>
          <PesticideMapDeletePointModalFooter>
            <Button 
              label="Не удалять"
              colorScheme="neutral"
              variant="outline"
              onClick={onDeleteModalClose}
            />
            <Button 
              label="Удалить метку"
              onClick={onDeleteModalSubmit}
            />
          </PesticideMapDeletePointModalFooter>
        </PesticideMapDeletePointModalBody>
      </Modal>

      <Modal
        isOpen={isNotPesticidesModalOpen}
        centered
        onClickOverlay={() => setIsNotPesticidesModalOpen(false)}
        onEsc={() => setIsNotPesticidesModalOpen(false)}
        style={{
          padding: 0
        }}
      >
        <PesticideMapNoPolygonsModalWrapper>
          <PesticideMapNoPolygonsModalIcon>
            <NotificationInfoIcon />
          </PesticideMapNoPolygonsModalIcon>
          <PesticideMapNoPolygonsModalContent>
            <PesticideMapNoPolygonsModalTitle>Нет районов распространения пестицидов в этой области</PesticideMapNoPolygonsModalTitle>
            <PesticideMapNoPolygonsModalText>Измените область поиска или параметры фильтров.</PesticideMapNoPolygonsModalText>
          </PesticideMapNoPolygonsModalContent>
            <Button 
              size="s"
              colorScheme="neutral"
              variant="secondary"
              iconPrefix={<CloseIcon />}
              style={{width: toRem(24)}}
              onClick={() => setIsNotPesticidesModalOpen(false)}
            />
        </PesticideMapNoPolygonsModalWrapper>
      </Modal>

      <PesticideMapFilters 
        isOpen={isFiltersOpen}
        onClose={() => setIsFiltersOpen(false)}
        onFiltersSubmit={onFiltersSubmit} />
      
      <PesticideMapPolygonModal 
        isOpen={isPolygonModalOpen}
        activePolygon={activePolygon}
        position={activePolygonModalPosition}
        onClose={closePolygonModal}
      />
    </PesticideMapWrapper>
  )
}